import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { LoginSecurityOverview } from "@/types/ApiResponses/Monitor";

export const getLoginSecurity = async (
  props: QueryProps<void>
): Promise<LoginSecurityOverview> => {
  const res = await api.client.get("/monitor/login-security", {
    signal: props.signal,
  });
  return res.data;
};
